import React, { useEffect, useState } from "react";
import { useProductData } from "@/zustand/productStore";
import Skeleton from "@children/components/ProductPackages/Skeleton";
import UpsellItem from "@children/components/ProductPackages/UpsellItem";
import { useUpsellData } from "@children/zustand/upsellStore";

const UpsellPackage = () => {
  const [initialLoad, setIntialLoad] = useState(true);
  const productsData = useProductData();
  const { upsellProduct } = useUpsellData();

  useEffect(() => {
    const element = document.getElementById(`productCard-${1}`);
    if (!element || initialLoad) return;
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio < 1) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        },
        {
          threshold: [0, 1],
        }
      );
      observer.observe(element);
      setTimeout(() => {
        return observer.disconnect();
      }, 310);
    }, 300);
  }, []);

  return (
    <>
      <div data-testid="products-label" className="productPackages__heading" id="products">
        You May Also Like
      </div>
      <div className="productPackages__wrapper">
        {productsData?.upsell_product ? (
          productsData?.upsell_product?.map((product, i) => (
            <UpsellItem
              key={i}
              product={product}
              active={upsellProduct?.product_list_unit_price === product?.product_list_unit_price}
              index={i}
            />
          ))
        ) : (
          <Skeleton units={1} />
        )}
      </div>
    </>
  );
};

export default UpsellPackage;
